/**
 * Generated by orval v7.17.0 🍺
 * Do not edit manually.
 * TFA API
 * API for TFA
 * OpenAPI spec version: 2.0.0 (api.admin.v1)
 */

/**
 * * `S` - Small
* `M` - Medium
* `L` - Large
* `XL` - Extra Large
* `XXL` - Double Extra Large
 */
export type AlphaSizesEnum = typeof AlphaSizesEnum[keyof typeof AlphaSizesEnum];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AlphaSizesEnum = {
  S: 'S',
  M: 'M',
  L: 'L',
  XL: 'XL',
  XXL: 'XXL',
} as const;
